import { useMobilePanel } from '@/components/layout/Navigation/mobile';
import { useSettingsModal } from '@/features/settings/hooks/useSettingsModal';
import { type WorkspaceTopMenuPorts } from '@heidi/workspace';

import { useJoinWorkspaceDialogPorts } from './join-workspace-dialog-ports';
import { trackWorkspaceShellEvent } from './track-workspace-shell-event';
import { isRecordingActiveForWorkspaceSwitch } from './workspace-switch-recording-check';

/**
 * The app half of `@heidi/workspace`'s `WorkspaceTopMenu`: the cross-domain
 * recording check, the settings modal opener, the analytics binding and the
 * join dialog's own ports.
 */
export const useWorkspaceTopMenuPorts = (): WorkspaceTopMenuPorts => {
  const { open: openSettingsModal } = useSettingsModal();
  const { dismissMobileSidebar } = useMobilePanel();
  const joinDialog = useJoinWorkspaceDialogPorts();

  return {
    isRecordingActive: isRecordingActiveForWorkspaceSwitch,
    onOpenSettings: () => {
      dismissMobileSidebar();
      openSettingsModal(undefined, 'sidebar');
    },
    track: trackWorkspaceShellEvent,
    joinDialog,
  };
};
